module.exports = __webpack_public_path__ + "static/media/alc-2.247adb57.jpg";